import { createContext, useContext, useState } from 'react'
import { classificationTaskService } from '../services/classificationTaskService'

 const classificationTaskContext = createContext()

 export const useClassificationTask = () => useContext(classificationTaskContext)


 export const ClassificationTaskProvider = ({ children }) => {

    
    //Obtener todas las clasificaiones
    const [classificationTasks, setClassificationTasks] = useState([])
    const [loadingClassificationTasks, setLoadingClassificationTasks] = useState(false)
    const getClassificationTasks = async (params) => {
        try {
            setLoadingClassificationTasks(true)
            const response = await classificationTaskService.getClassificationTasks(params)
            setClassificationTasks(response.data)
            setLoadingClassificationTasks(false)
            console.log(params)
        } catch (error) {
            console.log(error)
            setLoadingClassificationTasks(false)
        }
    }

    //Crear una clasificación
    const [loadingClassificationTask, setLoadingClassificationTask] = useState(false)
    const createClassificationTask = async (data) => {
        try {
            setLoadingClassificationTask(true)
            const response = await classificationTaskService.createClassificationTask(data)
            await getClassificationTasks()
            setLoadingClassificationTask(false)
            return true
        } catch (error) {
            console.log(error)
            setLoadingClassificationTask(false)
            throw error
        }
    }


    return (
        <classificationTaskContext.Provider value={{ 
            classificationTasks, 
            loadingClassificationTasks, 
            getClassificationTasks,
            createClassificationTask,
            loadingClassificationTask
        }}>
            {children}
        </classificationTaskContext.Provider>
    )
 }